import React, { useState, useEffect } from "react";
import LoginImg from '../../images/login1.png';
import { FiX } from "react-icons/fi";
import Loading from '../../images/loading.gif'; // Assuming you have a loading image
import { useNavigate } from "react-router-dom";
import { backendApi } from "../../api/apiService";
import { setStoredLogo } from "../../utils/logo";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { MdChevronRight } from "react-icons/md";
import {
    setSiteId,
    setUserData,
    setUserDetails,
    setUserId,
    setSiteHrmsFlag
} from "../../redux/reducers/loginSlice";
import { useDispatch } from "react-redux";
// import Loading from "../../images/loading.gif";
import { Loader } from "react-feather";
import { FiXCircle } from "react-icons/fi";
export default function LoginPopup(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [userName, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [forgotPassword, setForgotPassword] = useState(false);
    const [dataFlag, setDataFlag] = useState(false);
    // localStorage?.setItem("isLogin", 1); //! Comment later
    const [siteDetails, setSiteDetails] = useState([]);
    const [showCareers, setShowCareers] = useState(true);

    useEffect(() => {
        getSiteDetails();
    }, []);

    const goToCareers = () => {
        navigate(`/careers/${siteDetails[0].id}`);
    };

    const getSiteDetails = () => {
        const currentUrl = window.location.href;

        // Extract site ID from the URL
        const siteIdMatch = currentUrl.match(/\/(\d+)\/?$/);
        const siteId = siteIdMatch ? siteIdMatch[1] : "";

        // Extract web URL from the URL
        const webUrlMatch = currentUrl.match(/^(https?:\/\/[^\/]+)\/?/);
        const webUrl = webUrlMatch ? webUrlMatch[1] : "";
        var req = {
            functionName: "getSiteDetails",
            site_id: siteId ? siteId : "",
            web_url: webUrl ? webUrl : "",
        };
        backendApi(req).then((response) => {
            console.log("🚀 ~ backendApi ~ response:", response);
            if (response.success === "1") {
                setSiteDetails(response.dataSet);
                if (response.dataSet.length > 0) {
                    setShowCareers(true);
                    setStoredLogo(response.dataSet[0].company_logo);
                }
            } else {
                return false;
            }
        });
    };

    const Login = (e) => {
        // e.preventDefault();
        if (userName === "") {
            toast.warn("Please enter your Username", { containerId: "D" });
            return false;
        } else if (password === "") {
            toast.warn("Please enter your password", { containerId: "D" });
            return false;
        }
        setDataFlag(true);
        var req = {
            functionName: "login_auth",
            email_id: userName,
            password: password,
        };
        backendApi(req)
            .then((response) => {
                if (response.success === "1") {
                    dispatch(setUserDetails(response.userDetails));
                    dispatch(setUserData(response.userData));
                    dispatch(setSiteId(response.userDetails[0].site_id));
                    dispatch(setUserId(response.userData[0].id));
                    dispatch(setSiteHrmsFlag(response.siteDetails[0].is_hrms_connect))
                    localStorage.setItem('logo', response.siteDetails[0].company_logo);
                    localStorage.setItem("userId", response.userData[0].id);
                    localStorage.setItem("siteId", response.userDetails[0].site_id);
                    localStorage.setItem("role_id", response.userDetails[0].role_id);
                    // localStorage.setItem("isLogin", 1);
                    window.location.href = "/dashboard/dashboardMain";
                } else {
                    toast.warn("Wrong username or password", { containerId: "D" });
                    return false;
                }
            })
            .finally(() => setDataFlag(false));
    };

    const handleForgotPwd = () => {
        if (userName === "") {
            toast.warn("Please enter your Username", { containerId: "D" });
            return false;
        }
        setDataFlag(true);
        var req = {
            functionName: "resetPassword",
            email_id: userName,
        };
        backendApi(req)
            .then((response) => {
                if (response.success === "1") {
                    toast.success("Password sent to your Email Account", {
                        containerId: "D",
                    });
                    setForgotPassword(false);
                } else {
                    toast.warn("Something went wrong", { containerId: "D" });
                    return false;
                }
            })
            .finally(() => setDataFlag(false));
    };

    return (
        props.showLoginPopup && (
            <div className="login_popup">
                <ToastContainer
                    enableMultiContainer
                    containerId={"D"}
                    position="bottom-right"
                    autoClose={1500}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
                <div className="login_inner_popup">
                    <FiX className="popup_close_div" onClick={props.hideLoginPopup} />
                    <div className="left_login_inner_popup">
                        <div className="login_inner_svg">
                            <img src={LoginImg} className="img-fluid" alt="Login" />
                        </div>
                    </div>
                    <div className="right_login_inner_popup">
                        <div className="login_head">Login</div>
                        <div className="inner_login_container">
                            {forgotPassword ? (
                                <div className="login_form">
                                    <input
                                        type="text"
                                        className="login_input"
                                        placeholder="Email-Id"
                                        value={userName}
                                        onChange={(e) => setUsername(e.target.value)}
                                    />

                                    {dataFlag ? (
                                        <button className="login_btn" type="button"
                                            onClick={handleForgotPwd}
                                        >
                                            <img
                                                src={Loading}
                                                alt="loaderImg"
                                                width={20}
                                                height={20}
                                            />
                                        </button>
                                    ) : (
                                        <button className="login_btn" type="button"
                                            onClick={handleForgotPwd}
                                        >
                                            Submit
                                        </button>
                                    )}
                                    <div className="py-3">
                                        <span
                                            className="text-muted"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => setForgotPassword(true)}
                                        >
                                            Forgot password?
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p
                                            className="mb-0 me-2 text-primary cursor-pointer"
                                            onClick={() => setForgotPassword(false)}
                                        >
                                            Back to Login
                                        </p>
                                        <a href="/signup" className="btn btn-outline-primary btn-sm create-new">
                                            Create new
                                        </a>
                                    </div>
                                </div>
                            ) : (
                                <div className="login_form">
                                    <input
                                        type="text"
                                        className="login_input"
                                        placeholder="Email-Id"
                                        value={userName}
                                        onChange={(e) => setUsername(e.target.value)}
                                    />
                                    <div style={{ position: "relative", width: "100%" }}>
                                        <input
                                            className="login_input"
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Password"
                                            onChange={(e) => setPassword(e.target.value)}
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter") {
                                                    Login();
                                                }
                                            }}
                                        />
                                        <span className="showPswd_signUp">
                                            {showPassword ? (
                                                <FaEye onClick={() => setShowPassword(false)} />
                                            ) : (
                                                <FaEyeSlash onClick={() => setShowPassword(true)} />
                                            )}
                                        </span>
                                    </div>
                                    {dataFlag ? (
                                        <button className="login_btn" type="button">
                                            <img
                                                src={Loading}
                                                alt="loaderImg"
                                                width={20}
                                                height={20}
                                            />
                                        </button>
                                    ) : (
                                        <button className="login_btn" type="button" onClick={Login}>
                                            Login
                                        </button>
                                    )}
                                    <div className="py-3">
                                        <span
                                            className="text-muted"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => setForgotPassword(true)}
                                        >
                                            Forgot password?
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="mb-0 me-2 sign-in-form">Don't have an account?</p>
                                        <a href="/signup" className="btn btn-outline-primary btn-sm create-new">
                                            Create new
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    );
}
